// src/App.js
import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Login from "./components/login";
import Register from "./components/register";
import Home from "./pages/Home";
import MySaves from "./pages/MySaves";
import About from "./pages/Abount";
import People from "./pages/People";
import Settings from "./pages/Settings";
import Verified from "./pages/Verified";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthRoute from "./components/AuthRoute";
import { initAuthState } from "./utils/auth";
import "./App.css";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize the auth state with periodic checks
    const cleanup = initAuthState(navigate);
    
    return () => {
      cleanup(); // Cleanup on unmount
    };
  }, [navigate]);

  return (    
    <Routes>
      <Route path="/" element={
        <AuthRoute>
          <Login />
        </AuthRoute>
      } />
      <Route path="/register" element={
        <AuthRoute>
          <Register />
        </AuthRoute>
      } />
      
      {/* Protected Routes */}
      <Route path="/home" element={
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      } />

      <Route path="/verified" element={   
        <AuthRoute>
          <Verified />        
          </AuthRoute>     
      } />
      
      <Route path="/saves" element={
        <ProtectedRoute>
          <MySaves />
        </ProtectedRoute>
      } />
      
      <Route path="/people" element={
        <ProtectedRoute>
          <People />
        </ProtectedRoute>
      } />
      
      <Route path="/settings" element={
        <ProtectedRoute>
          <Settings />
        </ProtectedRoute>
      } />

      <Route path="/about" element={
        <ProtectedRoute>
          <About />
        </ProtectedRoute>
      } />
    </Routes>    
  );
}

export default App;